import React from 'react'
import { BetInfo } from '@core/Areas/KambiSports/Player/Components/BetHistory/BetInfo'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { getKambiCouponBetStatus } from '@core/Areas/KambiSports/Player/helpers/getKambiCouponBetStatus'
import {
  KambiHistoryCouponDisplayContext,
  type KambiHistoryCouponDisplayContextType,
} from '@core/Areas/KambiSports/Player/Components/BetHistory/context'
import { BetSelectionContainer } from '../Common/BetSelectionContainer'
import { CashedOutBanner } from './Components/CashedOutBanner'
import { trackBetLoopExpandSelection } from '@core/Areas/BetLoop/helpers/analytics'
import { HeightTruncateWrapper } from '../BetSelectionDisplay/Components/HeightTruncateWrapper'

export const KambiBetSelectionDisplay: React.FC<{
  coupon: BetLoopKambiShareCoupon
  cashedOutAtUtc?: string | null
  handleDisableCopyBet?(): void
  shouldDisableHeightTruncate?: true
  isForExternalShare?: boolean
  ownerAccountDisplayName?: string
  isMySharedBet?: boolean
}> = ({
  coupon,
  cashedOutAtUtc,
  handleDisableCopyBet,
  shouldDisableHeightTruncate,
  isForExternalShare = false,
  ownerAccountDisplayName,
  isMySharedBet,
}) => {
  const status = getKambiCouponBetStatus(coupon.bets[0]?.betStatus)
  const betStatus = status === 'Won' ? 'win' : status === 'No Payout' ? 'loss' : null

  const isHeightTruncateEnabled = !shouldDisableHeightTruncate && shouldEnableHeightTruncate(coupon)

  const handleOnChangeCallback = (expanded: boolean) => {
    trackBetLoopExpandSelection(expanded ? 'enable' : 'disable')
  }

  const contextValue = React.useMemo<KambiHistoryCouponDisplayContextType>(() => {
    return isForExternalShare
      ? { type: 'external-share', data: { cashedOutAtUtc } }
      : { type: 'betloop', data: { cashedOutAtUtc }, utils: { handleDisableCopyBet } }
  }, [isForExternalShare, cashedOutAtUtc, handleDisableCopyBet])

  return (
    <KambiHistoryCouponDisplayContext.Provider value={contextValue}>
      <BetSelectionContainer.Container displayStatus={betStatus}>
        <HeightTruncateWrapper
          isEnabled={isHeightTruncateEnabled}
          onChangeCallback={handleOnChangeCallback}
        >
          <BetSelectionContainer.Inner>
            <BetInfo historyCoupon={coupon} />
          </BetSelectionContainer.Inner>
        </HeightTruncateWrapper>
      </BetSelectionContainer.Container>

      {cashedOutAtUtc && ownerAccountDisplayName !== undefined && isMySharedBet !== undefined && (
        <CashedOutBanner
          ownerAccountDisplayName={ownerAccountDisplayName}
          isMySharedBet={isMySharedBet}
        />
      )}
    </KambiHistoryCouponDisplayContext.Provider>
  )
}

function shouldEnableHeightTruncate(coupon: BetLoopKambiShareCoupon): boolean {
  if (coupon.bets[0]?.couponRowIndexes.length > 2) {
    return true
  }
  return false
}
